/** 冷蔵庫関連のファイル */
export const FILE_URL_FRIDGE = {
  /** 工場出荷設定値 */
  INITIAL_SETTINGS: "/reizo/json/operation_initial_value.json",
  /** 電気代削減額の文言ファイル */
  REDUCTION_DESCRIPTION: "/reizo/json/specific_display_value.json"
};
  